var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___VDdaUm",
  "NI": "FloatingUnreadIndicators.module__slot___VDdaUm",
  "AH": "FloatingUnreadIndicators.module__slotTop___VDdaUm",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___VDdaUm",
  "q3": "FloatingUnreadIndicators.module__indicator___VDdaUm",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___VDdaUm",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___VDdaUm",
};

module.exports = exports;
